import { Type } from 'class-transformer';

import { IPagination, IQueryPaginationDto } from './utils';

export class IMission {
  id: string;
  creatorId: number;
  createdAt: string;
  name: string;
  status: number;
}

export class IMissionResponse {
  @Type(() => IMission)
  result: IMission;
}

export class IMissionListResponse extends IPagination {
  @Type(() => IMission)
  results: IMission[];
}

export class IMissionQueryDto extends IQueryPaginationDto {
  id?: string;
  name?: string;
}

export class IMissionPostDto {
  creatorId: number;
  name: string;
  status: number;
}

export class IMissionPatchDto {
  creatorId?: number;
  name?: string;
  status?: number;
}
